/* eslint-disable max-lines */
import { EmailType } from '@acp/shared';
import {
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
} from '@chakra-ui/react';
import { UseMutationResult } from '@tanstack/react-query';
import { forwardRef } from 'react';
import { ForwardEmailFormValues } from '../../features/email';
import { SendEmailForm } from '../forms/send-email-form';

// Define the ref type
export type SendEmailModalRef = {
    resetForm: () => void;
};

type Props = {
    title: string;
    propertyId: number;
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (formValues: ForwardEmailFormValues) => void;
    extraErrorMessage?: string;
    includeLandlords?: boolean;
    includePropertyManagers?: boolean;
    includeOccupants?: boolean;
    allowSubscribe?: boolean;
    previewAvailable?: boolean;
    downloadAvailable?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mutation: UseMutationResult<void, Error, any, unknown>;
    metaData: {
        emailType: EmailType;
        noticeId?: number;
        quoteId?: number;
        invoiceId?: number;
        propertyId?: number;
    };
};

export const SendEmailModal = forwardRef<SendEmailModalRef, Props>(
    (
        {
            title,
            propertyId,
            mutation,
            onClose,
            onSubmit,
            metaData,
            isOpen = false,
            extraErrorMessage = '',
            includeLandlords = false,
            includePropertyManagers = false,
            includeOccupants = false,
            allowSubscribe = false,
            previewAvailable = false,
            downloadAvailable = true,
        }: Props,
        ref
    ) => (
        <Modal
            isOpen={isOpen}
            autoFocus={false}
            onClose={onClose}
            size="2xl"
            trapFocus={false}
        >
            <ModalOverlay />
            <ModalContent pb={4}>
                <ModalHeader>{title}</ModalHeader>
                <ModalBody>
                    <SendEmailForm
                        propertyId={propertyId}
                        mutation={mutation}
                        onSubmit={onSubmit}
                        isEnabled={isOpen}
                        onClose={onClose}
                        metaData={metaData}
                        extraErrorMessage={extraErrorMessage}
                        includeLandlords={includeLandlords}
                        includePropertyManagers={includePropertyManagers}
                        includeOccupants={includeOccupants}
                        allowSubscribe={allowSubscribe}
                        previewAvailable={previewAvailable}
                        downloadAvailable={downloadAvailable}
                        ref={ref}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    )
);
